import React, { useState, useEffect } from 'react';
import NavigationMenu from './NavigationMenu'

function Header() {
  return (
    <header>
      <div className="wrapper">
        <NavigationMenu />
      </div>
    </header>
  );
}

export default Header;